var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8501 4.25V6.67M13.8501 17.76V19.784M13.8501 14.324V9.504",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.702 20C20.524 20 22 18.543 22 16.743V14.151C21.7156 14.1534 21.4336 14.0996 21.1701 13.9926C20.9066 13.8857 20.6668 13.7278 20.4645 13.5279C20.2623 13.328 20.1014 13.0902 19.9914 12.828C19.8813 12.5658 19.824 12.2844 19.823 12C19.823 10.81 20.794 9.85002 22 9.85002L21.999 7.25602C21.999 5.45602 20.522 3.99902 18.701 3.99902H5.3C3.478 4.00002 2 5.45702 2 7.25702V9.93502C3.206 9.93502 4.177 10.81 4.177 12.001C4.177 13.191 3.206 14.151 2 14.151V16.743C2 18.543 3.476 20 5.298 20H18.702Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTicket;